// Packages
const journalize = require('journalize');
import { timeFormat, format, precisionPrefix, formatPrefix, precisionFixed } from 'd3';

const titleCase = str => {
  return str.toLowerCase().split(' ').map(word => {
    return (word.charAt(0).toUpperCase() + word.slice(1));
  }).join(' ');
}

export const formatDate = date => {
  let month = journalize.apmonth(date);
  let day = timeFormat("%e")(date);
  return `${month} ${day}`;
}

export const formatNumberWithCommas = num => {
  return format(',')(num);
}

export const formatNumberPrefix = num => {
  // const p = precisionPrefix(1e5, 1.3e6);
  // const f = formatPrefix("." + p, 1.3e6);
  const f = format('.2s');
  return f(num);
}

export const formatNumberAnnotation = num => {
  const f = format('.3s');
  const ft = format(",");
  let formatted;
  if(f(num).includes("M")) {
    formatted = f(num).replace("M", " million");
    return formatted;
  } 
  // else if(f(num).includes("k")) {
  //   formatted = f(num).replace("k", " thousand")
  // }
  return ft(num);
}

export const formatNumberPrefixWithoutUnit = num => {
  const f = format('.2s');
  let formatted;
  if(f(num).includes("M")) {
    formatted = f(num).replace("M", "");
  } else if(f(num).includes("k")) {
    formatted = f(num).replace("k", "")
  }
  return formatted;
}

export const formatNumberPct = num => {
  const p = format(",.1f");
  return `${p(num)}%`;
}

export const formatCounties = county => {
  const exceptions = [
    {upper: "MCMULLEN", title: "McMullen"},
    {upper: "MCLENNAN", title: "McLennan"},
    {upper: "MCCULLOCH", title: "McCulloch"},
    {upper: "DEWITT", title: "DeWitt"},
  ]
  if(exceptions.map(e => e.upper).includes(county)) {
    return `${exceptions.find(e => e.upper == county).title} County`;
  } else if(county == "TOTAL") {
    return 'Texas';
  } else {
    return `${titleCase(county)} County`
  }
}

export const formatCountiesTitle = county => {
  const exceptions = [
    {upper: "MCMULLEN", title: "McMullen"},
    {upper: "MCLENNAN", title: "McLennan"},
    {upper: "MCCULLOCH", title: "McCulloch"},
    {upper: "DEWITT", title: "DeWitt"},
  ]
  if(exceptions.map(e => e.upper).includes(county)) {
    return `${exceptions.find(e => e.upper == county).title} County`;
  } else if(county == "TOTAL") {
    return 'Texas';
  } else {
    return `${titleCase(county)} County`
  }
}

export const formatCountiesShort = county => {
  const exceptions = [
    {upper: "MCMULLEN", title: "McMullen"},
    {upper: "MCLENNAN", title: "McLennan"},
    {upper: "MCCULLOCH", title: "McCulloch"},
    {upper: "DEWITT", title: "DeWitt"},
  ]
  if(exceptions.map(e => e.upper).includes(county)) {
    return exceptions.find(e => e.upper == county).title;
  } else if(county == "TOTAL") {
    return 'Texas';
  } else {
    return `${titleCase(county)}`
  }
}

export const formatYAxisTicks = num => {
  if (num >= 1000000 && num % 1000000 === 0) {
    return `${num / 1000000}M`;
  }

  const f = format('.2s');
  let formatted = f(num);

  if (formatted.includes('.0')) {
    formatted = formatted.replace('.0', '');
  }

  if (formatted.includes('k')) {
    formatted = formatted.replace('k', 'K');
  }

  return formatted;
}
